import {
  addDays,
  addMinutes,
  differenceInMinutes,
  endOfDay,
  isAfter,
  isBefore,
  isSameDay,
  startOfDay,
  startOfWeek,
  endOfWeek,
} from "date-fns";

export type Clock = () => Date;

export const systemClock: Clock = () => new Date();

export {
  addDays,
  addMinutes,
  differenceInMinutes,
  endOfDay,
  endOfWeek,
  isAfter,
  isBefore,
  isSameDay,
  startOfDay,
  startOfWeek,
};

export function isoString(d: Date): string {
  return d.toISOString();
}

export function fromIso(s: string): Date {
  return new Date(s);
}
